import React, { useEffect, useState, useRef  } from 'react';
import { Form, Input, InputNumber, Button, Spin, Alert, Card } from 'antd';
import api from '../../services/api';

const AboutManagement = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef(null);
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const { data } = await api.get('/pages/about');
        form.setFieldsValue(data);
        setLoading(false);
      } catch (err) {
        setErrorMsg('Failed to load about page data');
        setLoading(false);
      }
    };
    fetchAboutData();
  }, [form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await api.put('/pages/about', values);
      setSuccessMsg('About page updated successfully');
      setTimeout(() => setSuccessMsg(''), 3000);
        // Scroll to form top
  formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      setErrorMsg(err.response?.data?.message || 'Failed to update about page');
    }
  };

  if (loading) {
    return <Spin size="large" />;
  }

  return (
     <div ref={formRef}>
    <Card title="About Page Management" bordered={false}>
      {successMsg && <Alert message={successMsg} type="success" showIcon closable />}
      {errorMsg && <Alert message={errorMsg} type="error" showIcon closable />}
   
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="About Your Business"
          name="about_business"
          rules={[{ required: true, message: 'Please enter about business' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="About Company"
          name="about_company"
          rules={[{ required: true, message: 'Please enter about company' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Key Figure"
          name="about_key_figure"
          rules={[{ required: true, message: 'Please enter key figure' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Total Revenue"
          name="about_usd_revenue"
          rules={[{ required: true, message: 'Please enter USD revenue' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="INR Assets"
          name="about_usd_assets"
          rules={[{ required: true, message: 'Please enter INR assets' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Total Employees"
          name="about_total_employees"
          rules={[{ required: true, message: 'Please enter total employees' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Total Net Income"
          name="about_usd_net_income"
          rules={[{ required: true, message: 'Please enter USD net income' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Valuable Ideas"
          name="about_valuable_ideas"
          rules={[{ required: true, message: 'Please enter valuable ideas' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Industry Experience"
          name="about_industry_experience"
          rules={[{ required: true, message: 'Please enter industry experience' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Budget Friendly"
          name="about_budget_friendly"
          rules={[{ required: true, message: 'Please enter budget friendly' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Investment Planning"
          name="about_investment_planning"
          rules={[{ required: true, message: 'Please enter investment planning' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Business Growth"
          name="about_business_growth"
          rules={[{ required: true, message: 'Please enter business growth' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Financial Planning"
          name="about_financial_planning"
          rules={[{ required: true, message: 'Please enter financial planning' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Startup Business Awards"
          name="about_startup_business_awards"
          rules={[{ required: true, message: 'Please enter startup business awards' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Professional Skills"
          name="about_professional_skills"
          rules={[{ required: true, message: 'Please enter professional skills' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Business (Integer)"
          name="about_business_sk"  // <-- fixed name here
          rules={[{ required: true, message: 'Please enter business value' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Corporate (Integer)"
          name="about_corporate"
          rules={[{ required: true, message: 'Please enter corporate value' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Finance (Integer)"
          name="about_finance"
          rules={[{ required: true, message: 'Please enter finance value' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Strategy (Integer)"
          name="about_strategy"
          rules={[{ required: true, message: 'Please enter strategy value' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Update About Page
          </Button>
        </Form.Item>
      </Form>
    
    </Card>
      </div>
  );
};

export default AboutManagement;
